import axios from "axios";

const HOST_NEWS_API = "https://news.blueskydev.xyz";
// const HOST_NEWS_API = "http://localhost:5106/recruit";

export const getAllRecruitment = async () => {
  try {
    const URL = `${HOST_NEWS_API}/recruit/get`;
    const res = await axios.get(URL);

    const { code, message, data } = res.data;

    return { code, message, data };
  } catch (error) {
    console.log(error);
  }
  return { code: -99, message: "", data: [] };
};

export const getRecruitment = async (params) => {
  try {
    const URL = `${HOST_NEWS_API}/recruit/filter`;
    const res = await axios.post(URL, params);

    const { code, message, data } = res.data;

    return { code, message, data };
  } catch (error) {
    console.log(error);
  }
  return { code: -99, message: "", data: [] };
};

export const getRecruitmentById = async (id) => {
  try {
    const URL = `${HOST_NEWS_API}/recruit/get-by-id/${id}`;
    const res = await axios.get(URL);

    const { code, message, data } = res.data;

    return { code, message, data };
  } catch (error) {
    console.log(error);
  }
  return { code: -99, message: "", data: [] };
};

export async function postSubscribedRecruit(formData) {
  const res = await axios.post(
    `${HOST_NEWS_API}/SubscriedRecruit/create`,
    formData
  );
  const { code, message, data } = res.data;

  if (code < 0) {
    throw new Error(message);
  }

  return { code, message };
}
